<template>
    <div id="login">
      <form name="login-form" v-on:submit="loginFormSubmit">
        <input type="text" v-model="user.username" placeholder="请输入帐号"/>
        <input type="password" v-model="user.password" placeholder="请输入密码"/>
        <input type="submit" value="登录"/>
      </form>
      <form name="login-form1">
        <input type="text" v-model="user.username" placeholder="请输入帐号"/>
        <input type="password" v-model="user.password" placeholder="请输入密码"/>
        <input type="submit" value="登录2" @click="loginFormClick"/>
      </form>
      <form name="login-form2">
        <input type="text" v-model="user.username" placeholder="请输入帐号"/>
        <input type="password" v-model="user.password" placeholder="请输入密码"/>
        <input type="submit" value="登录3" @click="loginAuth"/>
      </form>
      <button class="button-test" @click="mallGoodsList">mallGoodsList</button>
      <button class="button-test" @click="mallGoodsDetails">mallGoodsDetails</button>
      <button class="button-test" @click="loginStatus">loginStatus</button>
      <button class="button-test" @click="oauthToken">oauthToken</button>
      <button class="button-test" @click="testUrlGetAuthServerPuk">testUrlGetAuthServerPuk</button>
      <div class="login-response" @click="loginStatus">
        <p v-if="null == this.responseData.loginStatus.data.data" v-model="this.responseData.loginStatus">未登录</p>
        <p v-else>{{this.responseData.loginStatus.data.data.username}}</p>
        <p>{{this.getResponse}}</p>
        <p>{{this.getResponse2}}</p>
        <p>{{this.responseData.goodList}}</p>
        <p>{{this.responseData.goodsDetails}}</p>
      </div>
    </div>
</template>

<script>
  import {
    login,login2,authServerToken,loginStatus,mallGoodsList,mallGoodsDetails,oauthToken,testUrlGetAuthServerPuk
  } from "./../../api/api";
  import {setLocalStorage, getLocalStorage, setLocalStorageToJsonString} from "./../../utils/CommonUtil";
  import {loginUserKey, userInfo} from "./../../utils/Config";
  import {getUserInfo} from './../../utils/UserUtil'


  export default {
        name: "login",
      methods: {
        loginFormSubmit: function () {
          console.log(this.user);
          const res = login(this.user);
          res.then((x) => {
            console.log(x);
            this.getResponse = x;
            if (this.getResponse.status) {

            }
          })
        },
        loginFormClick: function () {
          console.log(this.user);
          const res = login2(this.user);
          res.then((x) => {
            console.log(x);
            this.getResponse2 = x;
            let token = this.getResponse2.headers.token;
            console.log(this.user.username + "-token" + ":" + token);
            if (token) {
              userInfo.username = this.user.username;
              setLocalStorageToJsonString(loginUserKey, userInfo);
              debugger;
              setLocalStorage(this.user.username + "-token", token);
            }
            console.log("getLocalStorage:"+userInfo.username, getLocalStorage(userInfo.username + "-token"));
            //document.write(this.getResponse2.data);
          })
        },
        loginAuth: function () {
          console.log(this.user);
          const res = authServerToken(this.user);
          res.then((x) => {
            console.log(x);
            this.responseData.authTokenData = x;
            debugger;
            if (this.responseData.authTokenData.status === 200 && this.responseData.authTokenData.data.code === 200){
              let token = this.responseData.authTokenData.data.data;
              console.log(this.user.username + "-token" + ":" + token);
              if (token) {
                userInfo.username = this.user.username;
                debugger;
                setLocalStorageToJsonString(loginUserKey, userInfo);
                setLocalStorage(this.user.username + "-token", token);
              }
            }
            console.log("getLocalStorage:"+userInfo.username, getLocalStorage(userInfo.username + "-token"));
            //document.write(this.getResponse2.data);
          })
        },
        testUrlGetAuthServerPuk: function () {
          const res = testUrlGetAuthServerPuk();
          res.then((x) => {
            console.log(x);
            debugger;
          })
        },
        loginStatus: function () {
          console.log(this.queryVo);
          const res = loginStatus();
          res.then((x) => {
            console.log(x);
            this.responseData.loginStatus = x;
            if (this.responseData.loginStatus.data.code === 200){
              userInfo.username = this.responseData.loginStatus.data.data.username;
              userInfo.id = this.responseData.loginStatus.data.data.id;
              setLocalStorageToJsonString(loginUserKey, userInfo);
            }
            debugger;
            console.log(this.responseData);
            console.log(getLocalStorage(loginUserKey));
            console.log(getUserInfo());
          }).catch(reason => {

          })
        },
        mallGoodsList: function () {
          console.log(this.queryVo);
          const res = mallGoodsList(this.queryVo);
          res.then((x) => {
            console.log(x);
            this.responseData.goodList = x;
          })
        },
        mallGoodsDetails: function () {
          console.log(this.user);
          const res = mallGoodsDetails(this.user);
          res.then((x) => {
            console.log(x);
            this.responseData.goodsDetails = x;
            document.write(this.responseData.goodsDetails.data);
          })
        },
        oauthToken: function () {
          console.log(this.user);
          const res = oauthToken({
            'grant_type': 'authorization_code',
            'client_id': 'client_a',
            'client_secret': '123456',
            'code': 'O8GN0L'
          });
          debugger;
          res.then((x) => {
            debugger;
            console.log(x);
            this.responseData.oauthTokenData = x;
            let data = this.responseData.oauthTokenData.data;
            console.log('oauthToken',data);
          })
        }
      },
      data: function () {
        return {
          user: {
            username: "",
            password: ""
          },
          queryVo: {
            keyword: "",
            pageable: ""
          },
          responseData:{
            loginStatus: {
              data: {
                code: 200,
                data:{
                  username: "",
                  id: null
                }
              }
            },
            goodList: {},
            goodsDetails: {
              data: ""
            },
            oauthTokenData: {
              data: ""
            },
            authTokenData: {
              status: 200,
              data: {
                code: 200,
                data: ""
              }
            }
          },
          getResponse: {
            status: 200,
            data: {
            }
          },
          getResponse2: {
            status: 200,
            data: {
            },
            headers: {
              token: ""
            }
          }
        }
      },
    created() {
      this.loginStatus();
    }
  }
</script>

<style scoped>
  #login {
    display: block;
    height: auto;
  }
  .login-form {

  }
  .button-test {
    width: 100px;
    height: 30px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Login.vue